export default __webpack_public_path__ + "static/devops2-4379cd3dce77d4843edefec26cf075fd.jpeg";